var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95014 9.29872C10.4964 9.29872 11.7499 8.0452 11.7499 6.49897C11.7499 4.95271 10.4964 3.69922 8.95014 3.69922C7.40388 3.69922 6.15039 4.95271 6.15039 6.49897C6.15039 8.0452 7.40388 9.29872 8.95014 9.29872Z",
    stroke: "#686F7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05078 14.9003V14.2003C4.05078 11.4944 6.24439 9.30078 8.95035 9.30078C9.7018 9.30078 10.4137 9.46996 11.0502 9.77226",
    stroke: "#686F7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2496 16.3012L15.9496 12.1016L13.4998 13.3615L12.4499 12.1016L11.4 13.3615L8.9502 12.1016L9.65013 16.3012H15.2496Z",
    stroke: "#686F7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/Role.dba12a8da1238decd946bda7cffc989e.svg";
export { ForwardRef as ReactComponent };